import { Color } from '@opallabs/gem'
import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const assetMeta = {
  alignItems: 'center',
  contain: 'paint',
  display: 'flex',
  flexFlow: 'column nowrap',
  height: '100%',
  justifyContent: 'center',
  left: 0,
  position: 'absolute',
  textAlign: 'center',
  top: 0,
  transition: 'all 200ms ease',
  width: '100%',
  '.kuiper-icon-wrapper svg': {
    color: colors.n1.base,
    fill: colors.n1.base,
  },
}

const assetInfoWrapper = ({ showFilenameText }) => ({
  alignItems: 'center',
  alignSelf: 'center',
  backgroundColor: colors.white.base,
  borderRadius: 16,
  boxShadow: '0px 0px 6px 0px rgba(0,0,0,0.4)',
  boxSizing: 'border-box',
  color: colors.n1.base,
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '4px',
  height: 36,
  justifyContent: 'center',
  maxWidth: '90%',
  padding: showFilenameText ? '0px 8px' : '0px 4px',
  position: 'sticky',

  // Hide empty actions
  '& > :empty': {
    display: 'none',
  },
})

const filename = {
  alignItems: 'center',
  backgroundColor: 'white',
  borderRadius: '16px 0 0 16px',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  fill: colors.n5.base,
  flexFlow: 'row nowrap',
  fontFamily: 'Proxima Nova',
  fontSize: fontSizes.medium,
  fontWeight: fontWeights.medium,
  justifyContent: 'center',
  '.kuiper-icon-wrapper svg': {
    height: 12,
    width: 12,
    paddingBottom: 2,
  },
  '&:hover': {
    color: colors.gem.blue,
    fill: colors.gem.blue,
    '.kuiper-icon-wrapper svg': {
      color: colors.gem.blue,
      fill: colors.gem.blue,
    },
  },
}

const filenameText = {
  alignItems: 'center',
  alignSelf: 'center',
  borderRight: '1px solid #e7e7e7',
  display: 'inline-flex',
  height: 36,
  marginRight: 8,
  overflow: 'hidden',
  paddingRight: 8,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

const link = {
  color: 'inherit',
}

const assetTools = {
  // matches color used in current non-react overlay
  borderLeft: '1px solid #e7e7e7',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'row',
  gap: '2px',
  paddingInlineStart: 6,
}

const iconContainerOverride = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  blockSize: 12,
  inlineSize: 12,
}

const iconSvgOverride = {
  color: Color.light.Text.Default,
  fill: Color.light.Text.Default,

  '&:hover': {
    color: Color.light.Text.Accent,
    fill: Color.light.Text.Accent,
  },
}

const assetTool = {
  alignItems: 'center',
  display: 'flex',
  height: 36,
  justifyContent: 'center',
  width: 26,
}

const gearOptions = {
  marginBottom: -2,
}

export const styles = {
  assetInfoWrapper,
  assetMeta,
  assetTool,
  assetTools,
  filename,
  filenameText,
  gearOptions,
  iconContainerOverride,
  iconSvgOverride,
  link,
}
